import EmojiEventsRoundedIcon from "@mui/icons-material/EmojiEventsRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import QuestionAnswerRoundedIcon from "@mui/icons-material/QuestionAnswerRounded";
import SettingsIcon from '@mui/icons-material/Settings';
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import { Avatar, Box, Divider, Drawer, Toolbar } from "@mui/material";
import List from "@mui/material/List";
import * as React from "react";

import { styled } from "@mui/material";
import { Poppins } from "next/font/google";
import NavListItemButton from "./NavListItemButton";
import { StyledList, StyledMenuItem, StyledSelect } from "./StyledComponents";

import MenuBookIcon from "@mui/icons-material/MenuBook";
import { useEffect, useState } from "react";
import {
  getUserData,
  isOwner
} from "../../hooks/HelperFunctions";
import { apiRequest } from "../../utils/axiosInstance";

import GroupsIcon from "@mui/icons-material/Groups";
import PermMediaIcon from "@mui/icons-material/PermMedia";
import PersonIcon from "@mui/icons-material/Person";

import CircleIcon from "@mui/icons-material/Circle";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";

import InsightsIcon from "@mui/icons-material/Insights";
import { useRouter } from "next/navigation";
import { useDispatch, useSelector } from "react-redux";
import { CouponsIcon } from "../../assets/icons/CouponsIcon";
import { setActiveSelectedCourseIndex } from "../../redux/dashboardSlice";
import { setActiveOrgId } from "../../redux/orgSlice";
import SimpleBackdrop from "../Backdrop/SimpleBackdrop";
import styles from "./Menu.module.css";

const poppins = Poppins({
  weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
  subsets: ["latin"],
  display: "swap",
});

const PermanentDrawerContainer = styled(Box)(({ theme }) => ({
  fontFamily: poppins.style.fontFamily,
  display: "block",
  [theme.breakpoints.up("lg")]: {
    display: "flex",
  },
}));

const drawerWidth = 264;

export default function PermanentDrawer({ children, menuStatus, MenuClosed }) {
  const dispatch = useDispatch();

  const permittedModules = useSelector((state) => state.org.permittedModules);
  const userBasicInfo = useSelector((state) => state.userBasicInfo);

  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [selectedOption, setSelectedOption] = React.useState("");
  const [teachingAccounts, setTeachingAccounts] = useState([]);
  const [activeOrg, setActiveOrg] = useState(null);
  const [activeUserType, setActiveUserType] = useState(null);
  const router = useRouter();
  useEffect(() => {
    const orgId = localStorage.getItem("orgId");
    if (!orgId || !(orgId > 0)) {
      setActiveUserType("student");
    }
    if (orgId && orgId > 0) {
      setActiveUserType("teacher");
    }
    if (typeof window !== "undefined") {
      const teachingAccountsDataFromlocalstorage = JSON.parse(
        localStorage.getItem("teachingAccounts")
      );
      if (teachingAccountsDataFromlocalstorage?.length > 0) {
        setTeachingAccounts(teachingAccountsDataFromlocalstorage);
      }
    } else {
      return []; // Return an empty object if on the server side
    }
  }, []);

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
    if (event.target.value == 0) {
      localStorage.removeItem("orgId");
      localStorage.removeItem("selectedTeachingAccount");
      router.push(`/learner-home`);
    } else {
      const selectedTeachingAccount = teachingAccounts?.find(
        (account) => account?.orgId === event.target.value
      );
      if(selectedTeachingAccount?.accountStatus != "active"){
        return false
      }
      if (selectedTeachingAccount) {
        localStorage.setItem(
          "selectedTeachingAccount",
          JSON.stringify(selectedTeachingAccount)
        );
      }

      localStorage.setItem("orgId", event.target.value);
      if (menuStatus) {
        MenuClosed();
      }

      setActiveOrgHandler();

      dispatch(setActiveOrgId(event.target.value));
      dispatch(setActiveSelectedCourseIndex(null));

      router.push(`/teaching-home`);
    }
  };

  let userData = getUserData();
  const envType = process.env.NEXT_PUBLIC_PROJECT_ENV;

  useEffect(() => {
    getTeachingAccountsList();
    setActiveOrgHandler();
  }, []);

  const setActiveOrgHandler = () => {
    let activeOrgId = localStorage.getItem("orgId");
    if (activeOrgId && activeOrgId > 0) {
      setActiveOrg(activeOrgId);
    } else {
      setActiveOrg(null);
    }
  };

  const getTeachingAccountsList = async () => {
    let orgId = localStorage.getItem("orgId");
    try {
      const data = await apiRequest(
        `/orgPortal/getUserOrgsData?userId=${userData?.id || 0}`,
        "GET",
        null
      );

      if (data?.body) {
        setTeachingAccounts(data?.body);
        localStorage.setItem("teachingAccounts", JSON.stringify(data?.body));
      }
    } catch (error) {
      console.log(error);
      // setAllCoursesSalesInfo(null)
    }
  };

  const showTeachers = () => {
    let teacherListToShow = [];
    teachingAccounts?.map((singleTeacher) => {
      teacherListToShow?.push(
        <StyledMenuItem
          value={singleTeacher?.orgId}
          style={{ display: "flex", justifyContent: "left" }}
        >
          <Avatar alt="avatar" src={singleTeacher?.officialIcon} />
          <div>
            {singleTeacher?.accountType == "org"
              ? singleTeacher?.teachingAccName
                ? singleTeacher?.teachingAccName
                : singleTeacher?.orgFullName
              : singleTeacher?.teachingAccName}
            {singleTeacher?.accountStatus == "pending" && <p style={{margin : "10px 0px 0px 0px", color : "#723B13", background : "#FDF6B2", margin : "0px", borderRadius: "5px", padding : "2px 11px", width : "fit-content"}}>In review</p>}
            {singleTeacher?.accountStatus == "rejected" && (<>
              <div style={{display : "flex", gap : "4px"}}>
                <p style={{color : "#9B1C1C", background : "#FDE8E8", margin : "0px", borderRadius: "5px", padding : "2px 11px"}}>Rejected</p>
                <p style={{color : "#004FE0", margin : "0px", borderRadius: "5px", padding : "2px 11px", cursor : "pointer"}}>Appeal</p>
              </div>
              </>)}

          </div>
        </StyledMenuItem>
      );
    });
    return teacherListToShow;
  };
  const operationModules = ["users", "tracks", "team", "courses", "inbox"];



  const getStartedHandler = async () => {
    const userInfo = getUserData()

    if (userInfo && Object.keys(userInfo).length > 0) {

      setOpenBackdrop(true); // show loading spinner/backdrop

      try {
        let currentOrtId = localStorage.getItem("orgId")
        let teachingAccounts = localStorage.getItem("teachingAccounts") ? JSON.parse(localStorage.getItem("teachingAccounts")) : []

        let found = teachingAccounts.find((single) => single.orgId == currentOrtId)
        let jwtToken = localStorage.getItem("jwtToken")

        const postData = {
          orgId: currentOrtId,
          jwt_token: jwtToken,
          slug: found?.subDomain
        };
        const response = await apiRequest("/generateLoginCode", "POST", postData);

        const { code } = response;

        if (code) {

          // Construct Become a teacher URL with code
          const appBUrl = `${process.env.NEXT_PUBLIC_TEACHER_SETTINGS_URL}?code=${encodeURIComponent(code)}`;
          // console.log("🚀 ~ getStartedHandler ~ appBUrl:", appBUrl)
          // return false
          window.location.href = appBUrl;
        } else {
          console.error("No code returned from API");
        }

      } catch (error) {
        console.error("Error generating login code:", error);
      } finally {
        setOpenBackdrop(false);
      }
    } else {
      console.log("No user found");

      sessionStorage.setItem("from_become_a_teacher", true);

      setOpenSignUpModel(true)
    }

  }

  /**
   * close backdrop
   */
  const handleCloseBackdrop = () => {
    setOpenBackdrop(false);
  };

  return (
    <PermanentDrawerContainer>

      <SimpleBackdrop open={openBackdrop} handleClose={handleCloseBackdrop} />
      <Drawer
        sx={{
          width: drawerWidth,
          display: { xs: "none", sm: "none", md: "none", lg: "block" },
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
          },
          "& .MuiList-root": {
            padding: "0px 16px",
          },
        }}
        variant="permanent"
        anchor="left"
      >
        <Toolbar sx={{ "&.MuiToolbar-root": { minHeight: "80px" } }}>
          <a href="/">
            <img
              src="https://cdn.mytakbir.com/static-assets/logos/takbir-lms-learning-management-system-muslim-logo-3x.png"
              height={"32px"}
            />
          </a>
        </Toolbar>
        {/* {teachingAccounts && teachingAccounts?.length > 0 && ( */}
        <div className={styles.SwitcherDesktopView}>
          <div className="SwitcherSelecter">
            <List>
              <StyledSelect
                value={activeOrg || 0}
                onChange={handleChange}
                displayEmpty
                fullWidth
              >
                <StyledMenuItem
                  value="0"
                  style={{ display: "flex", justifyContent: "left" }}
                >
                  {userData?.image ? (
                    <Avatar
                      className={styles.AvatarIcon}
                      alt="Avatar"
                      src={userData?.image}
                    ></Avatar>
                  ) : (
                    <Avatar className={styles.AvatarIcon} alt="Avatar">
                      {" "}
                      {userData.firstName
                        ? Array.from(userData.firstName)[0]
                        : ""}{" "}
                    </Avatar>
                  )}
                  {userData?.firstName} {userData?.lastName}
                </StyledMenuItem>
                {showTeachers()}
              </StyledSelect>
            </List>
          </div>
        </div>
        {/* )} */}

        <StyledList>
          {activeUserType == "teacher" &&
            (operationModules?.some((module) =>
              permittedModules?.includes(module)
            ) ||
              isOwner()) && (
              <NavListItemButton
                path={
                  activeUserType == "teacher"
                    ? "/teaching-home"
                    : "/learner-home"
                }
                icon={<HomeRoundedIcon />}
                label="Dashboard"
              />
            )}
          {activeUserType == "student" && (
            <NavListItemButton
              path={"/learner-home"}
              icon={<HomeRoundedIcon />}
              label="Dashboard"
            />
          )}

          {activeUserType === "teacher" ? (
            (permittedModules?.includes("inbox") || isOwner()) && (
              <NavListItemButton
                path={"/inbox-teacher"}
                icon={<QuestionAnswerRoundedIcon />}
                label="Inbox"
              />
            )
          ) : (
            <NavListItemButton
              path="/inbox-student"
              icon={<QuestionAnswerRoundedIcon />}
              label="Inbox"
            />
          )}
        </StyledList>

        <Divider />

        <StyledList>
          {activeUserType === "teacher" ? (
            <>
              {(permittedModules?.includes("courses") || isOwner()) && (
                <NavListItemButton
                  path="/my-courses"
                  icon={<MenuBookIcon />}
                  label="Courses"
                />
              )}
              {(permittedModules?.includes("tracks") || isOwner()) && (
                <NavListItemButton
                  path="/tracks"
                  icon={<InsightsIcon />}
                  label="Tracks"
                />
              )}
              {(permittedModules?.includes("users") || isOwner()) && (
                <NavListItemButton
                  path="/users"
                  icon={<PersonIcon />}
                  label="Users"
                />
              )}
              {(operationModules?.some((module) =>
                permittedModules?.includes(module)
              ) ||
                isOwner()) && (
                  <NavListItemButton
                    path="/media-library-table-view"
                    icon={<PermMediaIcon />}
                    label="Media"
                  />
                )}
              {(permittedModules?.includes("team") || isOwner()) && (
                <div className={styles.SubMenuContainer}>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <GroupsIcon className={styles.SubMenuMainIcon} /> Team
                    </AccordionSummary>
                    <AccordionDetails>
                      <NavListItemButton
                        path="/team-listing"
                        icon={<CircleIcon className={styles.SubMenuIcon} />}
                        label="Members"
                      />
                      <NavListItemButton
                        path="/roles-permissions"
                        icon={<CircleIcon className={styles.SubMenuIcon} />}
                        label="Roles"
                      />
                    </AccordionDetails>
                  </Accordion>
                </div>
              )}
              {(permittedModules?.includes("coupons") || isOwner()) && (
                  <>
                    <Divider />
                    <NavListItemButton
                      path="/coupons"
                      icon={<CouponsIcon />}
                      label="Coupons"
                    />
                  </>
                )}
              <NavListItemButton
                icon={<SettingsIcon />}
                label="Settings"
                clickHandler={(e) => getStartedHandler()}
              />
            </>
          ) : (
            <>
              <NavListItemButton
                path="/my-learning"
                icon={<MenuBookIcon />}
                label="Learning"
              />
              {/* <NavListItemButton
              path="/calendar"
              icon={<EventRoundedIcon />}
              label="Calendar"
            /> */}
              <NavListItemButton
                path="/certificates"
                icon={<EmojiEventsRoundedIcon />}
                label="Certificates"
              />
            </>
          )}
        </StyledList>

        {activeUserType == "student" && (
          <>
            <Divider />
            <StyledList>
              <NavListItemButton
                path="/settings"
                icon={<SettingsRoundedIcon />}
                label="Settings"
              />
            </StyledList>
          </>
        )}
      </Drawer>

      {/* ================== MOBILE MENU STARTED ============================== */}
      <div className={styles.MobileMenu}>
        <div className={menuStatus || "MobileMenuHideDefault"}>
          <Toolbar sx={{ "&.MuiToolbar-root": { minHeight: "80px" } }}>
            <a href="/">
              <img
                src="https://cdn.mytakbir.com/static-assets/logos/takbir-lms-learning-management-system-muslim-logo-3x.png"
                height={"32px"}
              />
            </a>
          </Toolbar>
          {/* {teachingAccounts && teachingAccounts?.length > 0 && ( */}
          <div style={{ padding: "0 16px" }}>
            <List>
              <StyledSelect
                value={activeOrg || 0}
                onChange={handleChange}
                displayEmpty
                fullWidth
              >
                <StyledMenuItem
                  value="0"
                  style={{ display: "flex", justifyContent: "left" }}
                >
                  <Avatar
                    alt="avatar"
                    src={userData?.image}
                    className={styles.AvatarIcon}
                  />
                  {userData?.firstName} {userData?.lastName}
                </StyledMenuItem>
                {showTeachers()}
              </StyledSelect>
            </List>
          </div>
          {/* )} */}

          <StyledList>
            <NavListItemButton
              path={
                activeUserType == "teacher" ? "/teaching-home" : "/learner-home"
              }
              icon={<HomeRoundedIcon />}
              label="Dashboard"
            />

            {/* <NavListItemButton
            path="/learner-home"
            icon={<HomeRoundedIcon />}
            label="Home"
          /> */}
            {activeUserType === "teacher" ? (
              (permittedModules?.includes("inbox") || isOwner()) && (
                <NavListItemButton
                  path={"/inbox-teacher"}
                  icon={<QuestionAnswerRoundedIcon />}
                  label="Inbox"
                />
              )
            ) : (
              <NavListItemButton
                path="/inbox-student"
                icon={<QuestionAnswerRoundedIcon />}
                label="Inbox"
              />
            )}
          </StyledList>

          <Divider />

          <StyledList>
            {activeUserType === "teacher" ? (
              <>
                {(permittedModules?.includes("courses") || isOwner()) && (
                  <NavListItemButton
                    path="/my-courses"
                    icon={<MenuBookIcon />}
                    label="Courses"
                  />
                )}
                <NavListItemButton
                  path="/tracks"
                  icon={<MenuBookIcon />}
                  label="Tracks"
                />

                <NavListItemButton
                  path="/users"
                  icon={<PersonIcon />}
                  label="Users"
                />

                <NavListItemButton
                  path="/media-library-table-view"
                  icon={<PermMediaIcon />}
                  label="Media"
                />
                {(permittedModules?.includes("team") || isOwner()) && (
                  <div className={styles.SubMenuContainer}>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                      >
                        <GroupsIcon className={styles.SubMenuMainIcon} /> Team
                      </AccordionSummary>
                      <AccordionDetails>
                        <NavListItemButton
                          path="/team-listing"
                          icon={<CircleIcon className={styles.SubMenuIcon} />}
                          label="Members"
                        />
                        <NavListItemButton
                          path="/roles-permissions"
                          icon={<CircleIcon className={styles.SubMenuIcon} />}
                          label="Roles"
                        />
                      </AccordionDetails>
                    </Accordion>
                  </div>
                )}


              </>
            ) : (
              <>
                <NavListItemButton
                  path="/my-learning"
                  icon={<MenuBookIcon />}
                  label="Learning"
                />
                {/* <NavListItemButton
                  path="/calendar"
                  icon={<EventRoundedIcon />}
                  label="Calendar"
                /> */}
                <NavListItemButton
                  path="/certificates"
                  icon={<EmojiEventsRoundedIcon />}
                  label="Certificates"
                />
              </>
            )}
          </StyledList>

          {activeUserType == "student" && (
            <>
              <Divider />
              <StyledList>
                <NavListItemButton
                  path="/settings"
                  icon={<SettingsRoundedIcon />}
                  label="Settings"
                />
              </StyledList>
            </>
          )}
        </div>
      </div>
      {/* ================== MOBILE MENU STARTED ============================== */}

      <Box
        component="main"
        sx={{ flexGrow: 1, bgcolor: "background.default", p: 3 }}
        className={styles.AppBodyMobile}
      >
        {children}
      </Box>
    </PermanentDrawerContainer>
  );
}
